import {TimelineMax} from 'gsap';
const Shortcuts = require('../utils/Shortcuts');


function OpacityText(selector, inDuration, idleDuration, outDuration) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const tl = new TimelineMax({paused: true});

        tl.set(selector, {opacity: 0, y: '8vh'}, 'st');
        tl.to(selector, inDuration, {opacity: 1, y: '0vh'}, 'st');
        if (outDuration > 0)
            tl.to(selector, outDuration, {opacity: 0, y: '-8vh'}, 'st+=' + (inDuration + idleDuration));


        constructor.timeline = tl;
        _created = true;
        return tl;
    };

    constructor.destroy = () => {
        if (!_created) return;
        Shortcuts.destroyTimeline(constructor);
        _created = false;
    };

    constructor.startDuration = inDuration;
    constructor.totalDuration = inDuration + idleDuration + outDuration;

    return constructor;
}

module.exports = OpacityText;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/texts/OpacityText.js